// @core/api/endpoints/project/update_epic.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EpicResponse,
  UpdateEpicRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Update epic
 * Updates epic properties including name, description, color, dates, and status.
 */
export async function UpdateEpic(
  project_id: string,
  epic_id: string,
  data: UpdateEpicRequest,
  options?: RequestOptions
): Promise<EpicResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/epics/:epic_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':epic_id', encodeURIComponent(epic_id));
  const requestOptions = options;
  return client.put<EpicResponse>(requestPath, data, requestOptions);
}
